import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog } from "@angular/material";
import { DataListDialog } from "../data-list-dialog";

@Component({
  selector: "app-promo-summary-review",
  templateUrl: "./promo-summary-review.component.html",
  styleUrls: ["./promo-summary-review.component.scss"],
})
export class PromoSummaryReviewComponent {
  @Input() combinedQuestionList: any[] = [];
  @Input() customConfigData: any;
  @Input() budgetCapAmtMain: any = [];
  @Input() budgetCapAmtForRegions: any = {};
  @Input() disableSaveButton: boolean = false;
  @Output() back = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() navigateToQuestion = new EventEmitter<any>();

  constructor(private dialog: MatDialog) {}

  getMultiSelectVals(item) {
    let selectedVal = this.customConfigData.challengeCriteria.criterias.find(
      (criteria) => {
        if (criteria.questionInfo.questionIdentifier === item.identifier) {
          return criteria;
        }
      }
    );
    if (
      item.identifier === "COUNTRY_INCLUDE" ||
      item.identifier === "COUNTRY_EXCLUDE"
    ) {
      return selectedVal.acceptedValues.length <= 5
        ? selectedVal.acceptedValues.map((x) => x.label).toString()
        : selectedVal.acceptedValues.length + " Records";
    }
    return selectedVal.acceptedValues.length <= 5
      ? selectedVal.acceptedValues.toString()
      : selectedVal.acceptedValues.length + " Records";
  }

  getMultiSelectValsInSummary(item) {
    let selectedVal = this.customConfigData.challengeCriteria.criterias.find(
      (criteria) => {
        if (criteria.questionInfo.questionIdentifier === item.identifier) {
          return criteria;
        }
      }
    );
    return selectedVal.acceptedValues;
  }

  openListContent(listData) {
    this.dialog.open(DataListDialog, {
      width: "514px",
      data: listData,
    });
  }

  getSelectedDates() {
    return `Start Date - ${new Date(
      this.customConfigData["startDate"]
    ).toDateString()}<br>End Date - ${new Date(
      this.customConfigData["endDate"]
    ).toDateString()}`;
  }

  getSelectedDate(item) {
    return new Date(this.customConfigData[item.identifier]).toDateString();
  }

  getEmailIds(questionInfo) {
    if (typeof this.customConfigData[questionInfo.identifier] == "object") {
      return this.customConfigData[questionInfo.identifier]
        .join(",")
        .toString();
    } else {
      return this.customConfigData[questionInfo.identifier];
    }
  }

  getTextAreaContent(questionInfo) {
    let selectedVal = this.customConfigData.challengeCriteria.criterias.find(
      (criteria) => {
        if (
          criteria.questionInfo.questionIdentifier === questionInfo.identifier
        ) {
          return criteria;
        }
      }
    );
    return selectedVal.acceptedValues.toString();
  }

  getBudgetForRegions() {
    let text = "";
    for (let property in this.budgetCapAmtForRegions) {
      text += `${property} - ${this.budgetCapAmtForRegions[property]}<br>`;
    }
    return text;
  }
}
